module.exports = __webpack_public_path__ + "static/media/MixedClass.3180f873.jpg";